'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

var SvgCaretUpFill = function (props, ref) { return (jsxRuntime.jsx("svg", _tslib.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: jsxRuntime.jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.8705 7.29L3.67652 15.5115C2.82752 16.482 3.51752 18 4.80602 18H19.194C19.783 18.0005 20.3178 17.6563 20.5612 17.12C20.8046 16.5836 20.7117 15.9545 20.3235 15.5115L13.1295 7.2915C12.8447 6.96554 12.4329 6.77853 12 6.77853C11.5671 6.77853 11.1554 6.96554 10.8705 7.2915V7.29Z", fill: "currentColor" }) }))); };
var ForwardRef = React.forwardRef(SvgCaretUpFill);

exports["default"] = ForwardRef;
//# sourceMappingURL=CaretUpFill.js.map
